import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';

// Dodatni plugin-i za MDEditor.Markdown, da se LaTeX formule ($...$) prikažu lepo svuda gde se prikazuje markdown.
export const mathPlugins = {
    remarkPlugins: [remarkMath],
    rehypePlugins: [rehypeKatex],
};
